import { useFilterValues } from '../store/selectors/useFilterValues';
import { useEagGridStore } from '../store/useEagGridStore';
import type { ExternalFilters } from '../types/ExternalFilters';
import type { FormToDataGridConnectorProps } from '../types/FormToDataGridConnectorProps';
import { unwrapFilterValues } from '../utils/unwrapFilterValues';
import { wrapFilterValues } from '../utils/wrapFilterValues';

/**
 * Bridges the EagGrid store filter state with external filter components.
 *
 * Returns `{values, onChange}` matching the `FormToDataGridConnectorProps` contract:
 * - `values`: flat `ExternalFilters` derived from the store's wrapped `filterValues`
 * - `onChange`: commits flat values back to the store in wrapped format
 *
 * Used by both `CustomFiltersPanel` (sidebar) and `ExternalFiltersPortal` (portal)
 * to avoid duplicating store↔filter bridge logic.
 *
 */
export function useExternalFilterBridge(): FormToDataGridConnectorProps {
  const store = useEagGridStore();
  const filterValues = useFilterValues();
  const values = unwrapFilterValues(filterValues) as ExternalFilters;
  const onChange = (newValues: ExternalFilters) => {
    store.setFilterValues(wrapFilterValues(newValues));
  };
  return {
    values,
    onChange
  };
}